"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "guardia-sanframondi": {
    "bb5ad778": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "skipSearch": false
    }],
    "fontanella": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c246c7cf": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2c3628f": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "skipSearch": false
    }],
    "portella": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01b7f827": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-croce": [{
      "hkey": "f203d128",
      "slug": "guardia-sanframondi",
      "name": "Guardia Sanframondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;